module.exports = __webpack_public_path__ + "static/media/white_joker.d65da53c.svg";